module.exports = __webpack_public_path__ + "img/logo.13e6522f.png";